import { ModalTextProps } from "@/contexts"

type ActionsType =
  | { type: 'CHANGE_PASSWORD_MODAL-open' }
  | { type: 'CHANGE_PASSWORD_MODAL-close' }
  | { type: 'LOGOUT_CONFIRMATION_MODAL-open' }
  | { type: 'LOGOUT_CONFIRMATION_MODAL-close' }
  | { type: 'CONFIRM_DIALOG_MODAL-open', payload: { modalText: ModalTextProps } }
  | { type: 'CONFIRM_DIALOG_MODAL-close' }
  | { type: 'ADD_NEW_MENU_MODAL-open' }
  | { type: 'ADD_NEW_MENU_MODAL-close' }
  | { type: 'CREATE_TENANT_FORM_MODAL-open' }
  | { type: 'CREATE_TENANT_FORM_MODAL-close' }
  | { type: 'CREATE_OWNER_FORM_MODAL-open' }
  | { type: 'CREATE_OWNER_FORM_MODAL-close' }
  | { type: 'CREATE_SUPPLIER_FORM_MODAL-open' }
  | { type: 'CREATE_SUPPLIER_FORM_MODAL-close' }

export type ElementsControllerProps = {
  isChangePasswordModalOpen: boolean
  isOwnerLogoutConfirmationModalOpen: boolean
  isLogoutConfirmationModalOpen: boolean
  isConfirmDialogModalOpen: boolean
  isAddMenuModalOpen: boolean
  isCreateTenantFormModalOpen: boolean
  isCreateOwnerFormModalOpen: boolean
  isCreateSupplierFormModalOpen: boolean
  modalText: ModalTextProps
}

export const OpeningElementsControllerReducer = (
  state: ElementsControllerProps,
  action: ActionsType
): ElementsControllerProps => {
  switch(action.type) {
    case 'CHANGE_PASSWORD_MODAL-open':
      return {
        ...state,
        isChangePasswordModalOpen: true
      }

    case 'CHANGE_PASSWORD_MODAL-close':
      return {
        ...state,
        isChangePasswordModalOpen: false
      }
        
    case 'LOGOUT_CONFIRMATION_MODAL-open':
      return {
        ...state,
        isLogoutConfirmationModalOpen: true
      }
    
    case 'LOGOUT_CONFIRMATION_MODAL-close':
      return {
        ...state,
        isLogoutConfirmationModalOpen: false
      }

    case 'CONFIRM_DIALOG_MODAL-open':
      return {
        ...state,
        isConfirmDialogModalOpen: true,
        modalText: action.payload.modalText
      }

    case 'CONFIRM_DIALOG_MODAL-close':
      return {
        ...state,
        isConfirmDialogModalOpen: false,
        modalText: {
          title: '',
          description: '',
          buttonText: '',
        }
      }

    case 'ADD_NEW_MENU_MODAL-open':
      return {
        ...state,
        isAddMenuModalOpen: true,
      }
    
    case 'ADD_NEW_MENU_MODAL-close':
      return {
        ...state,
        isAddMenuModalOpen: false,
      }

    case 'CREATE_TENANT_FORM_MODAL-open':
      return {
        ...state,
        isCreateTenantFormModalOpen: true,
      }

    case 'CREATE_TENANT_FORM_MODAL-close':
      return {
        ...state,
        isCreateTenantFormModalOpen: false,
      }

    case 'CREATE_OWNER_FORM_MODAL-open':
      return {
        ...state,
        isCreateOwnerFormModalOpen: true,
      }

    case 'CREATE_OWNER_FORM_MODAL-close':
      return {
        ...state,
        isCreateOwnerFormModalOpen: false,
      }

    case 'CREATE_SUPPLIER_FORM_MODAL-open':
      return {
        ...state,
        isCreateSupplierFormModalOpen: true,
      }

    case 'CREATE_SUPPLIER_FORM_MODAL-close':
      return {
        ...state,
        isCreateSupplierFormModalOpen: false,
      }

    default:
      return state
  }
}